var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icsi-form',{attrs:{"icsi":_vm.icsi,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }